import styled from '@mui/material/styles/styled';
import MuiSvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { FC } from 'react';

const SvgIcon = styled( MuiSvgIcon, {
  name: 'RotaryPhone',
  shouldForwardProp: ( prop ) => prop !== 'fill',
} )<SvgIconProps>( () => ( {
  // fill: '#f00',
  // stroke: 'currentColor',
  // strokeLinecap: 'round',
  // strokeLinejoin: 'round',
  // strokeWidth: '2.25px',
} ) );

SvgIcon.defaultProps = {
  viewBox: '0 0 512 512',
  focusable: 'false',
  'aria-hidden': 'true',
};

export const RotaryPhone: FC<SvgIconProps> = ( props ) => {

  const { fill = '#000', ...rest } = props;

  return (
    <SvgIcon {...rest}>
      <path d="M256 92.6c-69.6-.1-139.1 11.6-208.56 35.4 0 0-9.87 22.6-17.98 41.3a46.9 46.9 0 0 0-3.49 12.2c48.55-18.4 97.13-31 145.63-38 4.5-8.8 13.7-14.6 23.9-14.6h17.3c7.9 0 15.1 3.4 20.1 8.9 15.4-.6 30.8-.7 46.4-.1 4.9-5.5 12.1-8.8 19.8-8.8h17.3c10.1 0 19.1 5.6 23.7 14.1 48.7 6.6 97.2 19.4 145.9 38.3-.7-4-1.8-8.2-3.5-12-8.1-18.7-18-41.3-18-41.3-69.5-23.4-139-35.33-208.5-35.4zm-60.5 53.6c-4.7 0-8.8 3.4-9.6 8.1l-6.7 40.4c-12.1 2.2-23.9 5-35.3 8.4-9.8 3-17.6 10.4-21.2 19.9-13.8 37-48.72 130.6-48.72 130.6H438s-34.8-93.5-48.7-130.6c-3.5-9.5-11.4-17-21.2-19.9-11.4-3.4-23.2-6.2-35.3-8.4l-6.8-40.4c-.8-4.7-4.8-8.1-9.6-8.1h-17.3c-4.6 0-8.7 3.2-9.5 7.8l-2.2 10.6h-62.9l-2.2-10.6c-.8-4.6-4.8-7.8-9.5-7.8zm163.8 17.3-2.7 18.6c5.6 1.4 11.1 2.8 16.4 4.5 14 6.2 25.7 15.7 31.1 27.2l64.8 15.5c6.4-9.8 13.6-18.7 16.3-29.8-42-16.6-83.9-28.7-125.9-36zm-206.5.5c-42 7.5-84.01 19.4-126.02 35.6 3.05 11.7 9.6 19.6 16.31 29.7l64.81-15.5c5.9-13 17.2-23 31-27.2 5.5-1.6 11-3.1 16.5-4.5zM256 197.3c44.7 0 81 30.9 81 69s-36.3 68.9-81 68.9-81.1-30.8-81.1-68.9c0-38.1 36.4-69 81.1-69zm0 17.6c-30.1 0-54.5 20.8-54.5 46.4 0 25.6 24.4 46.4 54.5 46.4s54.4-20.8 54.4-46.4c0-25.6-24.3-46.4-54.4-46.4zM73.97 376.5l21.76 42.9H416.2l21.7-42.9z" fill={fill} fillOpacity="1">
      </path>
    </SvgIcon>
  );
};

export default RotaryPhone;

